export default __webpack_public_path__ + "static/media/download-on-the-app-store-apple.afd835eb.svg";